import { SET_USER_AUTHENTICATED, SET_USER_LOADING } from './actionTypes';

export const setUserAuthenticated = (authenticated) => ({
  type: SET_USER_AUTHENTICATED,
  payload: {
    authenticated,
  },
});

export const setUserLoading = (loading) => ({
  type: SET_USER_LOADING,
  payload: {
    loading,
  },
});
